import { FeedMode } from "@/src/utils/feed-sort";
import React from "react";
import { useTranslation } from "react-i18next";
import { Pressable, Text, View } from "react-native";

type Props = Readonly<{
  sort: FeedMode;
  onSortChange: (mode: FeedMode) => void;
  /** Show the Following option. Only true when the server enrolment check passed. */
  showFollowing?: boolean;
}>;

const OPTIONS: { mode: FeedMode; label: string }[] = [
  { mode: "hottest", label: "LABEL_SORT_HOTTEST" },
  { mode: "latest", label: "LABEL_SORT_LATEST" },
  { mode: "following", label: "FOLLOW_FOLLOWING" },
];

const FeedSortControl = ({ sort, onSortChange, showFollowing = false }: Props) => {
  const { t } = useTranslation();

  return (
    <View
      className="flex-row bg-obsidian rounded-xl border border-ash-3 self-start"
      testID="feed-sort-control"
      accessibilityRole="tablist"
    >
      {OPTIONS.filter((o) => o.mode !== "following" || showFollowing).map(({ mode, label }) => (
        <Pressable
          key={mode}
          testID={`sort-${mode}`}
          accessibilityRole="tab"
          accessibilityState={{ selected: sort === mode }}
          className={`px-4 py-2 rounded-xl ${sort === mode ? "bg-primary" : ""}`}
          onPress={() => onSortChange(mode)}
        >
          <Text
            className={`text-sm font-medium ${sort === mode ? "text-chalk" : "text-ash-2"}`}
          >
            {t(label)}
          </Text>
        </Pressable>
      ))}
    </View>
  );
};

export default FeedSortControl;
